import axios from "axios";
import { endUnauthorizedSession } from "./utils/unauthorizedSession";
import { canEndNormalSession } from "./utils/partnerAccess/sedeSession";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API_PAYMENTS}`,
});

API.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${process.env.REACT_APP_TOKEN_PAYMENTS}`;
  config.baseURL = `${process.env.REACT_APP_REST_API_PAYMENTS}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const jcnError = {
      message: error.response?.data?.userMessage || error.response?.data,
    };
    // Partner access: this client never carries the delegated token, so in
    // sede mode its failure says nothing about the sede and must not end the
    // normal session.
    if (jcnError.message === "UNAUTHORIZED" && canEndNormalSession()) {
      endUnauthorizedSession();
    }
    return Promise.reject(jcnError);
  }
);

export default API;
